import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { getClientListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getClientListing = (payload: getClientListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getClientListing`, payload);
      dispatch({
        type: action_types.GET_CLIENTS_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CLIENTS_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removeClientListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_CLIENTS_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};


export const getClientDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getClientDetails/${id}`);
      dispatch({
        type: action_types.GET_CLIENTS_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_CLIENTS_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeClientDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_CLIENTS_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};